/**
 * @generated SignedSource<<6a57b15b6a558f86448b0b878f125551>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoWrapper_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedShippingInfoWrapper_user";
};
export type PdpSharedShippingInfoWrapper_user$key = {
  readonly " $data"?: PdpSharedShippingInfoWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoWrapper_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7e4241d399c222849162e94f7748c8ad";

export default node;
